import { render, staticRenderFns } from "./LtiSearch.vue?vue&type=template&id=6332ab90"
import script from "./LtiSearch.vue?vue&type=script&lang=js"
export * from "./LtiSearch.vue?vue&type=script&lang=js"
import style0 from "./LtiSearch.vue?vue&type=style&index=0&id=6332ab90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports